// extracted by mini-css-extract-plugin
export default {"secondaryCard":"SecondaryCard_secondaryCard__LZ7gx","learningPath":"SecondaryCard_learningPath__Z4Pjn"};